<template>
    <modal @close="moveUserAdminCancelClick" hideFooter class="edit-modal" id="move-user-admin">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Move User</h3>
                    <p>
                        You can move an existing user from one account to another existing account.  All of their existing settings will be transferred as well.
                    </p>
                    <p>
                        Optionally, you can select if you want the transferred user to become the Primary User or Billing User on the account being transferred to.
                    </p>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Move User</h3>

                    <div class="td-banner danger my-2 dismissible" v-if="errorMessage">
                        <icon name="faTriangleExclamation" type="solid"></icon>
                        <p>{{errorMessage}}</p>
                        <icon type="solid" name="faXmark" aria-hidden="true" @click="errorMessage = ''"></icon>
                    </div>

                    <div class="md-col-2">
                        <div class="column">
                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">User: </label>
                                <span>{{ userProfile.firstName }} {{ userProfile.lastName }}</span>
                            </div>

                            <div class="mt-3 td-autocomplete">
                                <strong>To Account:</strong>
                                <div :class="[!selectedAccount && searchTermAccount ? 'focused' : '', 'auto-complete-input']">
                                    <div v-if="selectedAccount" class="td-selected-input mt-3">
                                        <span>
                                            {{ selectedAccount.display }}
                                            <a href="#" class="input-deselect" @click.prevent="selectAccount()">
                                                <icon typeof="solid" name="faXmark" aria-hidden="true"></icon>
                                            </a>
                                        </span>
                                    </div>
                                    <input v-if="!selectedAccount" type="text"
                                           placeholder="Enter account number or name"
                                           name="account"
                                           id="account"
                                           @focus.prevent="showAccountList = true"
                                           v-model="searchTermAccount"
                                           @keyup.enter="selectAccount(accountList.items[0])" />
                                </div>
                                <div :class="[!selectedAccount && showAccountList ? 'show-results' : 'hide-results', 'autocomplete-results']">
                                    <ul class="results-list" v-if="accountList.length > 0">
                                        <li v-for="(item, idx) in accountList" :key="idx">
                                            <a @click.prevent="selectAccount(item)" href="#">{{ item.display }}</a>
                                        </li>
                                    </ul>
                                    <ul v-else class="results-list">
                                        <li class="td-text-subdued pa-1">
                                            No accounts found
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold mt-0">
                                    Primary User
                                    <input v-model="model.isPrimary" name="isPrimary" type="checkbox" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold mt-0">
                                    Billing User
                                    <input v-model="model.isBilling" name="isBilling" type="checkbox" />
                                    <span></span>
                                </label>
                            </div>

                        </div>
                    </div>
                </form>
                <div class="actions" style="margin-top: 50px;">
                    <div>
                        <button class="td-text-left td-btn primary-outlined" @click="moveUserAdminCancelClick">Cancel</button>
                    </div>

                    <div class="save-btn">
                        <button class="td-text-right td-btn btn primary" @click="moveUserAdminSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>


    </modal>
</template>

<script>
    import script from './MoveUserAdmin';
    export default script;
</script>

<style lang="less">
    @import "./MoveUserAdmin.less";
</style>